<template>
  <h2 :class="classes">
    {{ currentProject.project_cipher }} {{ currentProject.name }} 
  </h2>
</template>

<script>
import { MIXIN_PTO_CURRENT_PROJECT } from '@/mixins/module/pto/project/mixinPTOCurrentProject'

export default {
  name: 'PTOProjectTitle',
  props: {
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  mixins: [MIXIN_PTO_CURRENT_PROJECT],
  computed: {
    classes () {
      return this.isEdit ? 'title mb-10 form__input--col-2' : 'subtitle info__title'
    }
  }
}
</script>
